import React, { FC, ReactElement } from 'react';
import { Info } from 'lucide-react';

import { TooltipSimple } from '@/shared/ui/tooltip-simple';

import type { FormFieldError } from '../../types';

import { FieldError, Switch } from '../../primitives';

export interface FormSwitchProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  subtitle?: string;
  hint?: string | ReactElement;
  error?: FormFieldError;
}

export const FormSwitch: FC<FormSwitchProps> = ({
  checked,
  disabled,
  error,
  hint,
  label,
  onCheckedChange,
  subtitle,
}) => (
  <div className="flex items-start justify-between gap-2">
    <div className="flex flex-1 flex-col">
      <div className="flex w-full items-start justify-between gap-2">
        <label className="flex cursor-pointer items-center gap-2">
          <Switch
            checked={checked}
            onCheckedChange={onCheckedChange}
            disabled={disabled}
          />
          {label && (
            <div className="flex flex-col">
              <span className="text-sm">{label}</span>
              {subtitle && (
                <span className="text-xs text-muted-foreground">
                  {subtitle}
                </span>
              )}
            </div>
          )}
        </label>
        {hint && (
          <TooltipSimple
            content={
              typeof hint === 'string' ? (
                <div dangerouslySetInnerHTML={{ __html: hint }} />
              ) : (
                hint
              )
            }>
            <Info className="size-[21px] cursor-pointer text-muted-foreground" />
          </TooltipSimple>
        )}
      </div>
      {!!error && (
        <>
          <div className="mb-2" />
          <FieldError error={error} />
        </>
      )}
    </div>
  </div>
);
